import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "caret-right-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.4141 15.2939L14.0041 12.7039C14.3941 12.3139 14.3941 11.6839 14.0041 11.2939L11.4141 8.70385C10.7841 8.07385 9.7041 8.52386 9.7041 9.41386L9.7041 14.5939C9.7041 15.4839 10.7841 15.9239 11.4141 15.2939Z" }, null, -1)
  ])))
}
export default { render: render }